import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import { images } from "../../utils/images";
import { Close } from "@material-ui/icons";
import { getBase64 } from "../../utils/tools";
import { connect } from "react-redux";

function BusinessDocuments(props) {
  const { t, classes } = props;
  const [certificateFile, setCertificateFile] = useState(null);
  const [articlesFile, setArticlesFile] = useState(null);
  const [poaOfCorporationFile, setPoaOfCorporationFile] = useState(null);
  const [companyReportFile, setCompanyReportFile] = useState(null);
  const [missingFields, setMissingFields] = useState([]);

  // Ids Array
  const [idsArray, setIdsArray] = useState([]);

  // Create File Input Selector
  const createFileSelector = (stateModifier) => {
    const fileSelector = document.createElement("input");
    fileSelector.setAttribute("type", "file");
    fileSelector.setAttribute("accept", ".png, .jpg, .pdf");
    fileSelector.addEventListener(
      "change",
      function (e) {
        fileUploaded(e.target.files[0], stateModifier);
      },
      false
    );
    return fileSelector;
  };

  const createIdFileSelector = (stateModifier) => {
    const fileSelector = document.createElement("input");
    fileSelector.setAttribute("type", "file");
    fileSelector.setAttribute("accept", ".png, .jpg, .pdf");
    fileSelector.addEventListener(
      "change",
      function (e) {
        idUploaded(e.target.files[0], stateModifier);
      },
      false
    );
    return fileSelector;
  };

  // Handle Image Uplaoded
  const fileUploaded = (file, stateModifier) => {
    let acceptedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "application/pdf",
    ];
    if (!acceptedTypes.includes(file.type)) {
      props.pushNotification({ message: "_invalidFileType", type: "error" });
      return;
    }

    if (file.size > 10485760) {
      props.pushNotification({ message: "_fileTooBig", type: "error" });
      return;
    }

    const photo = URL.createObjectURL(file);
    stateModifier({ photoUrl: photo, file: file });
  };

  //Handle Ids Array
  const idUploaded = (file, stateModifier) => {
    let acceptedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "application/pdf",
    ];
    if (!acceptedTypes.includes(file.type)) {
      props.pushNotification({ message: "_invalidFileType", type: "error" });
      return;
    }

    if (file.size > 10485760) {
      props.pushNotification({ message: "_fileTooBig", type: "error" });
      return;
    }

    const photo = URL.createObjectURL(file);
    stateModifier([...idsArray, { photoUrl: photo, file: file }]);
  };

  const certificateInput = createFileSelector(setCertificateFile);
  const articlesInput = createFileSelector(setArticlesFile);
  const poaOfCorporationInput = createFileSelector(setPoaOfCorporationFile);
  const companyReportInput = createFileSelector(setCompanyReportFile);

  const fileInputs = [
    {
      id: "certificate of incorporation and business registration",
      label: "_certificate",
      input: certificateInput,
      value: certificateFile,
      remove: () => {
        setCertificateFile(null);
      },
    },
    {
      id: "articles of association",
      label: "_articles",
      input: articlesInput,
      value: articlesFile,
      remove: () => {
        setArticlesFile(null);
      },
    },
    {
      id: "proof of address of the corporation",
      label: "_poaOfCorporation",
      input: poaOfCorporationInput,
      value: poaOfCorporationFile,
      remove: () => {
        setPoaOfCorporationFile(null);
      },
    },
    {
      id: "an official company report which was issued within the last year",
      label: "_companyReport",
      input: companyReportInput,
      value: companyReportFile,
      remove: () => {
        setCompanyReportFile(null);
      },
    },
    // {
    //   id: "identifications",
    //   label: "_identifications",
    //   input: identificationsInput,
    //   value: identificationsFile,
    //   remove: () => {
    //     setIdentificationsFile(null);
    //   },
    // },
  ];

  // Browse Files
  const browseFiles = (input) => {
    input.click();
  };

  // Remove File from ID Array
  const removeThisFile = (name) => {
    let ids = idsArray.filter((i) => i.file.name !== name);

    setIdsArray([...ids]);
  };

  const validateDataAndProceed = async () => {
    let businessDocs = {
      "certificate of incorporation and business registration": certificateFile,
      "articles of association": articlesFile,
      "proof of address of the corporation": poaOfCorporationFile,
      "an official company report which was issued within the last year":
        companyReportFile,
    };
    setMissingFields([]);
    let missingFields = [];
    let entries = Object.entries(businessDocs);

    entries.map((entry) => {
      if (entry[1] === null) {
        missingFields.push(entry[0]);
      }
    });

    if (missingFields.length) {
      props.pushNotification({ message: "missingFields", type: "error" });
      setMissingFields([...missingFields]);
      return;
    }

    let docsArray = [];
    for (var i = 0; i < entries.length; i++) {
      let doc64 = await getBase64(entries[i][1].file);
      let doc = {
        type: entries[i][0].toUpperCase(),
        data_uri: doc64,
      };

      docsArray.push(doc);
    }

    for (var i = 0; i < idsArray.length; i++) {
      let doc64 = await getBase64(idsArray[i].file);
      let doc = {
        type: "piece of identification",
        data_uri: doc64,
      };

      docsArray.push(doc);
    }

    await props.setDocuments(docsArray);
    await props.trigger(true);
  };

  return (
    <div className={`corporateStepContainer ${classes.businessDocuments}`}>
      <h2 dangerouslySetInnerHTML={{ __html: t("_corporateT7") }} />
      <p dangerouslySetInnerHTML={{ __html: t("_corporateP4") }} />
      <div className={`inputsContainer ${classes.inputRows}`}>
        <div className="left">
          {fileInputs.map((f, idx) => {
            return (
              <div className="singleFileInput" key={idx}>
                <p
                  className={`label ${
                    missingFields.includes(f.id) ? "invalidField" : ""
                  }`}
                >
                  {t(f.label)}
                </p>
                {f.value === null ? (
                  <button
                    className={`uploadBtn ${"uploadSoloBtn"}`}
                    onClick={(e) => browseFiles(f.input)}
                  >
                    {t("uploadFile")}
                  </button>
                ) : (
                  <div className="fileButton">
                    <p>{f.value.file.name}</p>
                    <Close onClick={f.remove} />
                  </div>
                )}
              </div>
            );
          })}
          <div className="singleFileInput idInputs">
            <p className="label">{t("_identifications")}</p>
            {idsArray.map((i, idx) => {
              return (
                <div className="fileButton" key={idx}>
                  <p>{i.file.name}</p>
                  <Close onClick={() => removeThisFile(i.file.name)} />
                </div>
              );
            })}
            <button
              className={`uploadBtn idBtn ${"uploadSoloBtn"}`}
              onClick={() => browseFiles(createIdFileSelector(setIdsArray))}
            >
              {t("uploadFile")}
            </button>
          </div>
        </div>
        <div className="right">
          <img src={images.illustrations.corpSolo7} />
        </div>
      </div>
      <div className="nextButtonContainer">
        <button onClick={() => validateDataAndProceed()}>{t("confirm")}</button>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {};
}

const styles = (theme) => ({
  businessDocuments: {
    "& .singleFileInput": {
      marginBottom: 16,
      "& .invalidField": {
        color: `${theme.colors.buttons.sell} !important`,
      },
      "& .uploadBtn": {
        ...theme.defaults.roundBtn,
        borderColor: theme.colors.buttons.green,
        background: "none",
        color: theme.colors.buttons.green,
        marginTop: 8,
        transition: ".3s",
        "&:hover": {
          background: theme.colors.buttons.green,
          color: theme.colors.text.textOnRed,
        },

        "&.uploadSoloBtn": {
          color: theme.colors.text.primary,
          textTransform: "capitalize",
        },
      },
      "& .fileButton": {
        padding: "0 8px",
        height: 40,
        width: 150,
        borderRadius: 4,
        textOverflow: "ellipsis",
        wordBreak: "keep-all",
        background: theme.colors.misc.dividers,
        display: "flex",
        alignItems: "center",
        marginTop: 8,
        position: "relative",
        "& p": {
          width: "90%",
          color: `${theme.colors.text.textOnRed} !important`,
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
        },
        "& svg": {
          fontSize: 16,
          color: `${theme.colors.text.textOnRed} !important`,
          marginLeft: 5,
          position: "absolute",
          right: 8,
          top: "50%",
          transform: "translateY(-50%)",
        },
      },
      "&.idInputs": {
        display: "flex",
        flexDirection: "column",
        "& .uploadBtn": {
          marginBottom: 8,
          maxWidth: 120,
        },
      },
    },
  },
});

export default withStyles(styles)(
  withTranslation()(connect(mapStateToProps, null)(BusinessDocuments))
);
